import { render, staticRenderFns } from "./CardPrioInfo.vue?vue&type=template&id=7f5c644f&scoped=true"
import script from "./CardPrioInfo.vue?vue&type=script&lang=js"
export * from "./CardPrioInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5c644f",
  null
  
)

export default component.exports